import type { SVGProps } from 'react';

const SvgNavigationReviews = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="m7 1.871-1.415 3.28a.68.68 0 0 1-.625.41H1.843L4.08 7.786a.67.67 0 0 1 .18.642l-.974 3.87 3.376-1.918a.68.68 0 0 1 .674 0l3.376 1.917-.973-3.869a.67.67 0 0 1 .179-.642l2.238-2.225H9.04a.68.68 0 0 1-.625-.41zM6.063.614c.353-.819 1.521-.819 1.874 0L9.488 4.21h3.49c.909 0 1.364 1.092.721 1.73l-2.547 2.531 1.074 4.267c.217.866-.716 1.568-1.496 1.125L7 11.745l-3.73 2.118c-.78.443-1.713-.26-1.496-1.125L2.848 8.47.3 5.941C-.342 5.3.113 4.21 1.02 4.21h3.491z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgNavigationReviews;
